import { gql } from '@apollo/client';
import {
  RecentAnalysisVisitFieldsFragment,
  RecentDashboardVisitFieldsFragment,
} from './fragments';

export const GET_RECENT_ACTIVITY = gql`
  query recentActivity {
    recentActivity {
      ... on RecentAnalysisVisit {
        ...RecentAnalysisVisitFields
      }
      ... on RecentDashboardVisit {
        ...RecentDashboardVisitFields
      }
    }
  }
  ${RecentAnalysisVisitFieldsFragment}
  ${RecentDashboardVisitFieldsFragment}
`;
